import { Coin } from '../schema';

export default function getDecimals(coins: Coin[] = [], coinId: string, defaultDecimals = 8) {
  if (!coins) {
    return defaultDecimals;
  }
  return (coins.find(coin => coin.id === coinId) || { decimals: defaultDecimals }).decimals;
}
